module.exports = __webpack_public_path__ + "img/Photo16.bfc85b0d.jpg";